export const JCA_TABLE_COLUMNS = [
  {
    field: 'cif_empresa',
    align: 'left',
    width: 120,
    sorting: false,
  },
  {
    field: 'estado',
    align: 'left',
    width: 200,
    type: 'combo',
    comboId: 'estados_jca',
  },
  {
    field: 'tipo_instalacion',
    align: 'left',
    width: 100,
  },
  {
    field: 'fecha_creacion_jca',
    type: 'date',
    align: 'left',
    width: 140,
  },
  {
    field: 'fecha_jca',
    type: 'date',
    align: 'left',
    width: 140,
  },
  {
    field: 'situacion_suministro',
    align: 'left',
    width: 180,
  },
  {
    field: 'via',
    align: 'left',
    width: 400,
    render: (rowData) =>
      `${rowData.tipo_via ?? ''} ${rowData.via ?? ''} ${rowData.numero ?? ''}, ${
        rowData.poblacion ?? ''
      } (${rowData.codigopostal ?? ''}), ${rowData.provincia ?? ''}`,
  },
  // {
  //   field: 'nombre_gremio',
  //   align: 'left',
  //   width: 200,
  // },
]

export const JCA_EXPORT_COLUMNS = [
  { field: 'escenario' },
  { field: 'tipo_documento' },
  { field: 'id' },
  { field: 'estado' },
  { field: 'motivos_rechazo' },
  { field: 'fecha_estado', type: 'date' },
  { field: 'tipo_gas' },
  { field: 'une' },
  { field: 'tipo_instalacion' },
  { field: 'cups' },
  { field: 'cod_derivacion' },
  { field: 'provincia' },
  { field: 'poblacion' },
  { field: 'codigopostal' },
  { field: 'tipo_via' },
  { field: 'nombre_via' },
  { field: 'via' },
  { field: 'numero' },
  { field: 'anexo' },
  { field: 'bloque' },
  { field: 'escalera' },
  { field: 'piso' },
  { field: 'puerta' },
  { field: 'resultado' },
  { field: 'anomalias' },
  { field: 'cod_anomalias' },
  { field: 'situacion_suministro' },
  { field: 'fecha_jca', type: 'date' },
  { field: 'numero_factura' },
  { field: 'importe_factura' },
  { field: 'fecha_factura', type: 'date' },
  { field: 'observaciones' },
  { field: 'lopd_aceptacion' },
  { field: 'fecha_creacion_ip', type: 'date' },
  { field: 'nombre_empresa' },
  { field: 'cif_empresa' },
  { field: 'email_empresa' },
  { field: 'idusuario_empresa' },
  { field: 'iban_validado' },
  { field: 'iban_temporal' },
  { field: 'provincia_empresa' },
  { field: 'poblacion_empresa' },
  { field: 'cod_postal_empresa' },
  { field: 'reg_industrial_empresa' },
  { field: 'telefono_empresa' },
  { field: 'fecha_creacion_jca', type: 'date' }, //Según el excel de referencia, debería ser fecha creación empresa (campo que no está incluido en la respuesta de BE)
  { field: 'identificador_inspector' },
  { field: 'nombre_instalador' },
  { field: 'apellidos_instalador' },
  { field: 'categoria_instalador' },
  { field: 'nombre_gestor' },
  { field: 'apellidos_gestor' },
]

export const DEFAULT_QUERY = { _pagina: '1', _num_x_pagina: '10' }
